import axios from 'axios';
import { toastr } from 'react-redux-toastr';

import { URL } from '../../assets/js/constants';
import { toggleShowDialog } from './dialog';

function produtoLoading(data) {
    return {
        type: 'PRODUTO_LOADING',
        payload: data
    }
}

function produtoProcessing(data) {
    return {
        type: 'PRODUTO_PROCESSING',
        payload: data
    }
}

export function produtoSalvo(data) {
    return {
        type: 'PRODUTO_SAVED',
        payload: data
    }
}

export function carregarProdutos(data) {
    return {
        type: 'PRODUTOS_FETCHED',
        payload: data
    }
}

export function carregarProduto(data) {
    return {
        type: 'PRODUTO_FETCHED',
        payload: data
    }
}

export function carregarCorProduto(data) {
    return {
        type: 'COR_PRODUTO_FETCHED',
        payload: data
    }
}

export function carregarTamanhoProduto(data) {
    return {
        type: 'TAMANHO_PRODUTO_FETCHED',
        payload: data
    }
}

export function carregarEstampaProduto(data) {
    return {
        type: 'ESTAMPA_PRODUTO_FETCHED',
        payload: data
    }
}

export function carregarUploadedFiles(data) {
    return {
        type: 'UPLOADED_FILES',
        payload: data
    }
}

function carregarExistingFiles(data) {
    return {
        type: 'EXISTING_FILES',
        payload: data
    }
}

function atualizarUploadedFiles(data) {
    return {
        type: 'UPDATE_UPLOADED_FILES',
        payload: data
    }
}

function deletarUploadedFile(data) {
    return {
        type: 'DELETED_UPLOAD_FILE',
        payload: data
    }
}

export function getProdutos(idNegocio) {
    return dispatch => {
        dispatch(produtoLoading(true));
        axios.get(`${URL}/produtos/negocio/${idNegocio}`)
            .then(resp => {
                dispatch(carregarProdutos(resp.data));
                dispatch(produtoLoading(false));
            })
            .catch(e => {
                dispatch(produtoLoading(false));
                toastr.error('Erro', 'Encontramos problemas ao tentar trazer seus produtos.' + e.message);
            })
    }
}

export function getProduto(id) {
    return dispatch => {
        dispatch(produtoLoading(true));
        axios.get(`${URL}/produtos/gestao/${id}`)
            .then(resp => {
                dispatch(carregarProduto(resp.data));
                dispatch(produtoLoading(false));
            })
            .catch(e => {
                dispatch(produtoLoading(false));
                toastr.error('Erro', 'Encontramos problemas ao tentar trazer o produto.' + e.message);
            })
    }
}

export function getProdutoReduzido(id) {
    return dispatch => {
        dispatch(produtoLoading(true));
        axios.get(`${URL}/produtos/reduzido/${id}`)
            .then(resp => {
                dispatch(carregarProduto(resp.data));
                dispatch(produtoLoading(false));
            })
            .catch(e => {
                dispatch(produtoLoading(false));
                toastr.error('Erro', 'Encontramos problemas ao tentar trazer o produto.' + e.message);
            })
    }
}

export function getProdutoUrl(url) {
    return dispatch => {
        axios.get(url)
            .then(resp => {
                dispatch(carregarProduto(resp.data));
            })
    }
}

export function addProduto(values) {
    return dispatch => {
        dispatch(produtoProcessing(true));
        axios.post(`${URL}/produtos`, values)
            .then(resp => {
                dispatch(carregarProduto(resp.data));
                dispatch(produtoSalvo(true));
                dispatch(produtoProcessing(false));
                toastr.success('Sucesso', 'Produto cadastrado com sucesso.');
            })
            .catch(e => {
                dispatch(produtoSalvo(false));
                dispatch(produtoProcessing(false));
                if (e.status === 400) {
                    const { errors } = e
                    errors.forEach(erro => {
                        toastr.error(e.msg, 'Campo: ' + erro.fieldName + '. Mensagem: ' + erro.message);
                    })
                } else if (e.response && e.response.data) {
                    const { msg } = e.response.data;
                    toastr.error('Erro', msg);
                } else {
                    toastr.error('Erro', 'Houve um erro inesperado ao tentar salvar o produto. Entre em contato com o administrador.');
                }
            })
    }
}

export function editProduto(values) {
    return dispatch => {
        dispatch(produtoProcessing(true));
        axios.put(`${URL}/produtos`, values)
            .then(resp => {
                dispatch(carregarProduto(resp.data));
                dispatch(produtoSalvo(true));
                dispatch(produtoProcessing(false));
                toastr.success('Sucesso', 'Produto atualizado com sucesso.');
            })
            .catch(e => {
                dispatch(produtoSalvo(false));
                dispatch(produtoProcessing(false));
                if (e.status === 400) {
                    const { errors } = e
                    errors.forEach(erro => {
                        toastr.error(e.msg, 'Campo: ' + erro.fieldName + '. Mensagem: ' + erro.message);
                    })
                } else if (e.response && e.response.data) {
                    const { msg } = e.response.data;
                    toastr.error('Erro', msg);
                } else {
                    toastr.error('Erro', 'Houve um erro inesperado ao tentar salvar o produto. Entre em contato com o administrador.');
                }
            })
    }
}

export function deletarVariacaoDoProduto(id) {
    return dispatch => {
        // Retornamos a Promise do axios para que quem chama possa usar .then() ou await
        axios.delete(`${URL}/produtos/variacao/${id}`)
            .then(resp => {
                dispatch(toastr.success('Sucesso', 'Variação excluída.'));
                return true; // Sucesso
            })
            .catch(e => {
                if (e.response && e.response.data) {
                    const { msg } = e.response.data;
                    dispatch(toastr.error('Erro', msg));
                } else {
                    dispatch(toastr.error('Erro', 'Servidor fora do ar'));
                }
                return false; // Falha
            });
    }
}

//export function deletarVariacaoDoProduto(id) {
//    return axios.delete(`${URL}/produtos/variacao/${id}`);
//}

export function addProdutoOld(values) {
    var formData = new FormData();
    formData.append("produto", JSON.stringify(values));
    formData.append("imagem", values.imagem);

    return dispatch => {
        axios.post(`${URL}/produtos`, formData)
            .then(resp => dispatch(getProdutoUrl(resp.headers.location)))
            .then(_ => dispatch(toastr.success('Sucesso', 'Produto cadastrado com sucesso.')))
            .catch(e => {
                if (e.status === 400) {
                    const { errors } = e
                    errors.forEach(erro => {
                        toastr.error(e.msg, 'Campo: ' + erro.fieldName + '. Mensagem: ' + erro.message)
                    })
                }
            })
    }
}

export function uploadImagemProduto(produto) {
    return [
        carregarProduto(produto),
        toggleShowDialog('uploadImagemProduto')
    ]
}

export function addImagemProduto(values) {
    return dispatch => {
        const formData = new FormData();
        formData.append('file', values.file);
        // Enviando dados extras como campos simples de formulário (mais comum em APIs)
        formData.append('descricao', JSON.stringify({ idProduto: values.idProduto, ordem: values.ordem, principal: values.principal }));

        axios.post(`${URL}/produtos/imagem`, formData, {
            // O Axios define o Content-Type: multipart/form-data automaticamente com FormData
            onUploadProgress: e => {
                const progress = parseInt(Math.round((e.loaded * 100) / e.total));
                // O idTemp aqui é único para cada arquivo disparado no loop
                dispatch(atualizarUploadedFiles({ idTemp: values.idTemp, progress }));
            }
        })
            .then(resp => {
                const responseData = resp && resp.data ? resp.data : {};

                if (process.env.NODE_ENV !== 'production') {
                    console.log('[addImagemProduto] upload response data:', responseData);
                }

                const mappedId = Number(
                    responseData.id
                    || responseData.ID
                    || responseData.idImagem
                    || responseData.imagemId
                    || (responseData.imagem && responseData.imagem.ID)
                    || (responseData.imagem && responseData.imagem.id)
                    || 0
                );
                const mappedUrl =
                    responseData.url
                    || responseData.imagemUrl
                    || (responseData.imagem && responseData.imagem.url)
                    || null;

                if (!Number.isFinite(mappedId) || mappedId <= 0) {
                    toastr.error('Erro', `Upload concluído sem ID válido para ${values.file.name}.`);
                    dispatch(atualizarUploadedFiles({ idTemp: values.idTemp, error: true, uploaded: false }));
                    return;
                }

                dispatch(atualizarUploadedFiles({
                    idTemp: values.idTemp,
                    url: mappedUrl,
                    uploaded: true,
                    id: mappedId
                }));
            })
            .catch(() => {
                toastr.error('Erro', `Falha ao subir ${values.file.name}`);
                dispatch(atualizarUploadedFiles({ idTemp: values.idTemp, error: true }));
            });
    }
}

export function getImagensProduto(value) {
    return dispatch => {
        dispatch(produtoLoading(true));
        axios.get(`${URL}/produtos/${value}/imagens`)
            .then(resp => {
                dispatch(carregarExistingFiles(resp.data));
                dispatch(produtoLoading(false));
            })
            .catch(e => {
                dispatch(produtoLoading(false));
                toastr.error('Erro', 'Encontramos problemas ao tentar trazer as imagens.' + e.message);
            })
    }
}

export function updateImagemProduto(value) {
    return dispatch => {
        axios.put(`${URL}/produtos/imagem/${value}`)
            .then(resp => dispatch(getImagensProduto(resp.data.idProduto)))
            .catch(e => toastr.error('Erro', 'Encontramos problemas ao tentar atualizar a imagem.' + e.message))
    }
}

export function salvarOrdemImagens(idProduto, imagensOrdenadas) {
    return dispatch => {
        // Extraímos apenas os IDs na ordem em que estão na tela
        const ordenacao = imagensOrdenadas
            .map((img, index) => ({
                id: Number(img.id),
                ordem: index + 1, // 1ª foto = ordem 1, 2ª = ordem 2...
                principal: index === 0, // A primeira é sempre a principal
                idProduto: idProduto
            }))
            .filter((img) => Number.isFinite(img.id) && img.id > 0);

        if (ordenacao.length === 0) {
            toastr.warning('Aviso', 'Não há imagens salvas para reordenar.');
            return;
        }

        axios.put(`${URL}/produtos/${idProduto}/reordenar-imagens`, ordenacao)
            .then(() => {
                toastr.success('Sucesso', 'Ordem das imagens atualizada!');
                // Opcional: recarregar as imagens para garantir sincronia
                dispatch(getImagensProduto(idProduto));
            })
            .catch(e => toastr.error('Erro', 'Falha ao salvar nova ordem.'));
    }
}

export function deleteImagemProduto(id) {
    return dispatch => {
        axios.delete(`${URL}/produtos/imagem/${id}`)
            .then(() => {
                // Importante: certifique-se que o reducer remova o arquivo da lista uploadedFiles
                dispatch({ type: 'DELETE_UPLOADED_FILE', payload: id });
                toastr.success('Sucesso', 'Imagem removida.');
            })
            .catch(e => toastr.error('Erro', 'Não foi possível deletar.'));
    }
}

export function getCorProduto() {
    return dispatch => {
        axios.get(`${URL}/produtos/cores`)
            .then(resp => dispatch(carregarCorProduto(resp.data)))
            .catch(e => toastr.error('Erro', 'Encontramos problemas ao tentar trazer as cores.' + e.message))
    }
}

export function getTamanhoProduto() {
    return dispatch => {
        axios.get(`${URL}/produtos/tamanhos`)
            .then(resp => dispatch(carregarTamanhoProduto(resp.data)))
            .catch(e => toastr.error('Erro', 'Encontramos problemas ao tentar trazer os tamanhos.' + e.message))
    }
}

export function getEstampaProduto() {
    return dispatch => {
        axios.get(`${URL}/produtos/estampas`)
            .then(resp => dispatch(carregarEstampaProduto(resp.data)))
            .catch(e => toastr.error('Erro', 'Encontramos problemas ao tentar trazer as estampas.' + e.message))
    }
}

export function deletarProduto(value) {
    return dispatch => {
        axios.delete(`${URL}/produtos/deletar/${value.id}`)
            .then(_ => dispatch(getProdutos(value.vendedor.id)))
            .then(_ => dispatch(toastr.success('Sucesso', 'Produto excluído com sucesso!')))
            .catch(e => {
                try {
                    const { msg } = e.response.data;
                    toastr.error('Erro', msg);
                } catch (e) {
                    return false;
                }
            }
            )
    }
}

export function addVideoProduto(values) {
    return dispatch => {
        const formData = new FormData();

        // Mantém o arquivo binário do vídeo (Blob/File)
        formData.append('file', values.file);

        // Enviando apenas os dados necessários para o vídeo (idProduto)
        formData.append('descricao', JSON.stringify({ idProduto: values.idProduto }));

        // Ajustado o endpoint para refletir o upload de vídeos do produto
        axios.post(`${URL}/produtos/video`, formData, {
            onUploadProgress: e => {
                const progress = parseInt(Math.round((e.loaded * 100) / e.total));
                // Atualiza o progresso no Redux usando o idTemp único
                dispatch(atualizarUploadedFiles({ idTemp: values.idTemp, progress }));
            }
        })
            .then(resp => {
                // Upload concluído com sucesso
                dispatch(atualizarUploadedFiles({
                    idTemp: values.idTemp,
                    url: resp.data.url, // URL pública retornada pelo storage do seu backend
                    uploaded: true,
                    id: resp.data.id    // ID do registro gerado no banco de dados
                }));
            })
            .catch(() => {
                toastr.error('Erro', `Falha ao subir o vídeo: ${values.file.name}`);
                dispatch(atualizarUploadedFiles({ idTemp: values.idTemp, error: true }));
            });
    }
}

export function getVideoProduto(value) {
    return dispatch => {
        dispatch(produtoLoading(true));
        axios.get(`${URL}/produtos/${value}/video`)
            .then(resp => {
                dispatch(carregarExistingFiles(resp.data));
                dispatch(produtoLoading(false));
            })
            .catch(e => {
                dispatch(produtoLoading(false));
                toastr.error('Erro', 'Encontramos problemas ao tentar trazer o vídeo.' + e.message);
            })
    }
}

export function deleteVideoProduto() {

}